// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1_tAb"};